import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoPhoneInputModule } from 'mojo-phone-input';

import { SharedDirectivesModule } from '@shared/directives';
import { ImageUploadModule } from '@shared/image-upload/image-upload.module';
import { LocationInputModule } from '@shared/location/location-input.module';
import { SocialInfoModule } from '@shared/social-info/social-info.module';

import { CandidateFormRoutingModule } from './candidate-form-routing.module';
import { CandidateFormModalComponent } from './container/candidate-form-modal.container';
import { CandidateFormComponent } from './container/candidate-form.container';

const containers = [CandidateFormComponent, CandidateFormModalComponent];

@NgModule({
  imports: [
    ImageUploadModule,
    LocationInputModule,
    SharedDirectivesModule,
    CommonModule,
    ReactiveFormsModule,
    MojoAvatarModule,
    SocialInfoModule,
    CandidateFormRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MojoPhoneInputModule,
  ],
  declarations: [...containers],
  exports: [...containers],
})
export class CandidateFormModule {}
